export const MIN_WORD_SIZE = 11;
export const MAX_WORD_SIZE = 100;
export const ENLARGE_VALUE = 2;
